import AiTier from "./AiTier";
import {Feature} from "./Feature";

class Organization {
    constructor(
        public id?: string,
        public name?: string,
        public organizationId?: string,
        public features?: Feature[],
        public tags?: string[],
        public aiTier?: AiTier,
        public allowAiTierLimitExceeded?: boolean,
        public aiHardCreditLimitPerMonth?: number,
        public autoRunSystemAiExtractorsOnOrganizationSources?: boolean,
        public creditsUsedThisMonth?: number,
        public userCount?: number,
        public activeUserCount?: number,
        public vulReportDefinitionCount?: number) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const organization = new Organization();

        organization.id = data.id;
        organization.name = data.name;
        organization.organizationId = data.organizationId;
        organization.features = data.features;
        organization.tags = data.tags || [];
        organization.aiTier = AiTier.fromPOJO(data.aiTier);
        organization.allowAiTierLimitExceeded = data.allowAiTierLimitExceeded;
        organization.aiHardCreditLimitPerMonth = data.aiHardCreditLimitPerMonth;
        organization.autoRunSystemAiExtractorsOnOrganizationSources = data.autoRunSystemAiExtractorsOnOrganizationSources;
        organization.creditsUsedThisMonth = data.creditsUsedThisMonth;
        organization.userCount = data.userCount;
        organization.activeUserCount = data.activeUserCount;
        organization.vulReportDefinitionCount = data.vulReportDefinitionCount;

        return organization;
    }

}

export function aiTierCreditLimit(organization: Organization) {
    return organization.aiTier?.maxCreditsPerMonth;
}

export function effectiveAiCreditLimit(organization?: Organization | null) {
    if (!organization?.aiTier) {
        return undefined;
    }

    if (organization.allowAiTierLimitExceeded && organization.aiHardCreditLimitPerMonth !== undefined) {
        return organization.aiHardCreditLimitPerMonth;
    }

    return organization.aiTier.maxCreditsPerMonth;
}

export default Organization;
